import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

import { VideoStreamProvider } from '@features/video/providers';

// Страница турнира и страница партии: трансляция участника переживает переходы между ними
export const Route = createFileRoute('/club/$clubId_/tournament/_video')({
  component: Layout,
});

function Layout() {
  const { clubId, tournamentId } = useParams({ strict: false });
  if (!clubId || !tournamentId) return <Outlet />;
  return (
    <VideoStreamProvider clubId={clubId} tournamentId={tournamentId}>
      <Outlet />
    </VideoStreamProvider>
  );
}
